import { Component,  OnInit } from '@angular/core';
import { ModulesManagerService } from 'src/app/classes/Module/modules-manager.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  public manager: ModulesManagerService
  public Title = "STR_UNDEFINED_TITLE"
  constructor(manager : ModulesManagerService) { 
    this.manager = manager
  }

  ngOnInit() {
  }

}
